import { render, staticRenderFns } from "./ToothFocusControls.vue?vue&type=template&id=06446a45&scoped=true&"
import script from "./ToothFocusControls.vue?vue&type=script&lang=js&"
export * from "./ToothFocusControls.vue?vue&type=script&lang=js&"
import style0 from "./ToothFocusControls.vue?vue&type=style&index=0&id=06446a45&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06446a45",
  null
  
)

export default component.exports